import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/**
 * Center-spine timeline (matches design): glyphs ride a vertical spine, home events on the
 * left (flush to the spine), away on the right; minute sits under each glyph.
 */
export function getMatchHubEventsTimelineStyles(theme: Theme) {
  return StyleSheet.create({
    wrap: {
      position: 'relative',
      paddingVertical: theme.spacing.xs,
    },
    spine: {
      position: 'absolute',
      top: theme.spacing.sm,
      bottom: theme.spacing.sm,
      left: '50%',
      width: 2,
      marginLeft: -1,
      backgroundColor: theme.gray[200],
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 9,
    },
    side: {
      flex: 1,
      minWidth: 0,
    },
    sideHome: {
      alignItems: 'flex-end',
    },
    sideAway: {
      alignItems: 'flex-start',
    },
    center: {
      width: 44,
      alignItems: 'center',
    },
    minute: {
      fontSize: 10.5,
      fontWeight: '700',
      color: theme.gray[500],
      marginTop: 3,
      fontVariant: ['tabular-nums'],
    },
    glyph: {
      width: 30,
      height: 30,
      borderRadius: 15,
      backgroundColor: theme.background.card,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[200],
      alignItems: 'center',
      justifyContent: 'center',
    },
    glyphBall: {
      width: 30,
      height: 30,
      borderRadius: 15,
      backgroundColor: theme.white,
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardGlyph: {
      width: 12,
      height: 16,
      borderRadius: 2,
      backgroundColor: theme.accent,
    },
    cardGlyphRed: {
      backgroundColor: theme.error,
    },
    /** goal / card / var line: score pill or card sits beside the name, mirrored per side. */
    mainLineHome: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 7,
    },
    mainLineAway: {
      flexDirection: 'row-reverse',
      alignItems: 'center',
      gap: 7,
    },
    scorePill: {
      backgroundColor: theme.background.inset,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[300],
      borderRadius: 6,
      paddingHorizontal: 7,
      paddingVertical: 2,
    },
    scorePillText: {
      fontSize: 12,
      fontWeight: '800',
      color: theme.accent,
      fontVariant: ['tabular-nums'],
    },
    mainText: {
      fontSize: 14,
      fontWeight: '700',
      color: theme.gray[900],
      flexShrink: 1,
    },
    mainTextMuted: {
      color: theme.gray[500],
    },
    subText: {
      fontSize: 12,
      color: theme.gray[500],
      marginTop: 1,
    },
    subTextAway: {
      textAlign: 'left',
    },
    subLineHome: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
    },
    subLineAway: {
      flexDirection: 'row-reverse',
      alignItems: 'center',
      gap: 5,
    },
    subIn: {
      fontSize: 13.5,
      fontWeight: '700',
      color: theme.success,
    },
    subOut: {
      fontSize: 12.5,
      fontWeight: '500',
      color: theme.error,
    },
    /** HT / FT divider pill. */
    divider: {
      alignItems: 'center',
      paddingVertical: 10,
    },
    dividerPill: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      backgroundColor: theme.background.inset,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[300],
      borderRadius: 999,
      paddingHorizontal: 14,
      paddingVertical: 5,
    },
    dividerLabel: {
      fontSize: 11,
      fontWeight: '800',
      letterSpacing: 1,
      color: theme.gray[500],
    },
    dividerScore: {
      fontSize: 12,
      fontWeight: '800',
      color: theme.white,
      fontVariant: ['tabular-nums'],
    },
    periodInfo: {
      fontSize: 12,
      color: theme.gray[500],
      textAlign: 'center',
      fontWeight: '600',
      paddingVertical: theme.spacing.sm,
    },
    emptyText: {
      fontSize: 13,
      color: theme.gray[500],
    },
  });
}
